"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.replace");
require("core-js/modules/es6.function.name");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  props: {
    title: {
      type: String,
      default: "上传"
    },
    accept: {
      type: String,
      default: ".docx,.doc,.xlsx,.pptx,.ppt,.pdf,.png,.jpeg,.jpg,.gif,.zip,.rar,.txt,.mp4,.flv,.3gp,.avi"
    }
  },
  data: function data() {
    return {
      uploadFileUrl: process.env.VUE_APP_BASE_API + "/common/upload",
      formatArray: [],
      loading: false
    };
  },
  methods: {
    handMenu: function handMenu(path) {
      this.$router.push(path);
    },
    uploadSuccess: function uploadSuccess(res, file) {
      if (res.code == 1) {
        res.fileName = file.name;
        this.loading = false;
        this.$emit("successData", res);
      }
    },
    beforeUpload: function beforeUpload(file) {
      this.loading = true;
      if (this.accept) {
        var str = "/.(" + this.accept.replace(/,/g, "?|") + "?" + ")$/i";
        var fileName = file.name.toLowerCase();
        var name = eval(str).test(fileName);
        if (!name) {
          this.$message({
            dangerouslyUseHTMLString: true,
            message: "支持文件格式：" + "\n" + this.accept,
            type: "warning"
          });
          return false;
        }
      }
      var isLt2M = file.size / 1024 / 1024 < 600;
      if (!isLt2M) {
        this.$message.error("上传文件大小不能超过600MB!请刷新后重新上传600M以内文件！");
        return false;
      }
    },
    handleFormatError: function handleFormatError() {
      // 文件格式上传不正确
      this.$Notice.warning({
        title: "上传文件格式错误",
        desc: "文件格式不正确, 请选择" + this.formatArray + "格式文件上传。"
      });
    },
    uploadError: function uploadError() {
      this.$Message.error("上传失败！");
      this.loading = false;
    }
  }
};